import React from 'react';
import { Radio } from 'antd';
import classnames from 'classnames';
import './RadioGroup.scss';
import OText from '../CText/OText';
import { useAddAccesibilityAttributesToAll } from 'hook/helper.hook';

const OptionLabel = props => {
  const { customHtmlLabel, label } = props;
  if (customHtmlLabel) {
    return <OText text={label} />;
  } else {
    return label;
  }
};
function RadioGroup({
  datatestid,
  options,
  onChange,
  value,
  checkboxStyle,
  starRatingGroup,
  customClass,
  customRadioGroupClass,
  radioClass,
  roundedPills,
  customHtmlLabel,
  ...props
}) {
  const onRadioSelect = e => {
    const { value } = e.target;
    onChange(value);
  };

  let radioStyle = props.radioStyle || {
    display: 'block',
    marginBottom: '12px',
  };
  if (customClass) {
    radioStyle = null;
  }

  const groupClass = classnames('radiogroup-container', customClass, {
    'checkbox-styled-radio': checkboxStyle,
    'star-rating-group': starRatingGroup,
    'rounded-pills-group': roundedPills,
  });

  useAddAccesibilityAttributesToAll('.ant-radio-input', [
    {
      attribute: 'tabindex',
      value: -1,
    },
  ]);

  return (
    <div
      className={groupClass}
      data-testid={datatestid ? `${datatestid}-container` : null}
    >
      <Radio.Group
        onChange={onRadioSelect}
        value={value}
        className={customRadioGroupClass}
      >
        {options.map((option, i) => (
          <React.Fragment
            aria-checked={Number(value) >= Number(option?.value)}
            tabIndex={0}
            role="radio"
            onKeyDown={e => {
              if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                onRadioSelect({ target: { value: option.value } });
              }
            }}
          >
            <Radio
              key={i}
              style={radioStyle}
              className={radioClass}
              value={option.value}
              {...props}
              aria-label={option.value}
            >
              <OptionLabel
                label={option.label}
                customHtmlLabel={customHtmlLabel}
              />
            </Radio>
          </React.Fragment>
        ))}
      </Radio.Group>
    </div>
  );
}

export { RadioGroup };
